// THIS FILE IS AUTO GENERATED - do not edit!

import { forwardRef, type JSX } from 'react';

import { SvgIcon, type SvgIconProps } from '../lib/SvgIcon.js';

const WarningIconComponent = /* @__PURE__ */ forwardRef<
  SVGSVGElement,
  SvgIconProps
>((props: SvgIconProps, forwardedRef): JSX.Element => {
  return (
    <SvgIcon data-iconname="WarningIcon" ref={forwardedRef} {...props}>
      <path d="M9.372 7.913h1.507v4.54H9.372z" />
      <path d="M10.125 13.461A1.007 1.007 0 0 0 9.12 14.47a1.007 1.007 0 0 0 1.005 1.008 1.007 1.007 0 0 0 1.005-1.008 1.007 1.007 0 0 0-1.005-1.009" />
      <path d="M9.693 2.098c-.3.144-.527.573-.98 1.432L2.325 15.646c-.406.768-.608 1.153-.57 1.466a1 1 0 0 0 .424.708C2.437 18 2.87 18 3.736 18h12.778c.866 0 1.299 0 1.557-.18a1 1 0 0 0 .424-.708c.038-.313-.164-.698-.57-1.466L11.537 3.53c-.453-.859-.68-1.288-.98-1.432a1 1 0 0 0-.864 0m.432 1.989 6.539 12.4H3.586z" />
    </SvgIcon>
  );
});

/**
 * Use when something needs attention
 * @public
 */
export const WarningIcon = /* @__PURE__ */ Object.assign(WarningIconComponent, {
  displayName: 'WarningIcon',
});
